import api from '../api/axios';
import { OpcionesCorreos, PaginaCorreos, FiltrosCorreos } from '../types/correo';
import { ResultadoNotificacion } from '../types/evaluador';

export const correoService = {
  /** Correo del coordinador a los estudiantes marcados; los emails se resuelven en el servidor. */
  notificarEstudiantes: async (payload: { ruts: number[]; asunto: string; cuerpo: string }): Promise<ResultadoNotificacion> => {
    const { data } = await api.post<ResultadoNotificacion>('coordinacion/estudiantes/notificar/', payload);
    return data;
  },

  /** Bitácora paginada de todos los correos del sistema. */
  list: async (filtros: FiltrosCorreos): Promise<PaginaCorreos> => {
    const { data } = await api.get<PaginaCorreos>('coordinacion/correos/', { params: filtros });
    return data;
  },

  opciones: async (): Promise<OpcionesCorreos> => {
    const { data } = await api.get<OpcionesCorreos>('coordinacion/correos/opciones/');
    return data;
  },
};
